import { FindOptionsOrderValue } from "interfaces/IQuery";
import * as S from "./styles";

type Label = {
  text: string;
  value: string;
};

interface FilterProps {
  labels: Label[];
  onClicks: (() => void)[];
  onChange?: (value: FindOptionsOrderValue) => void;
  order: boolean;
  filter?: string;
  selectedTab?: string;
}

export default function Filter({
  labels,
  onClicks,
  onChange,
  order,
  selectedTab,
}: FilterProps) {
  return (
    <S.Container>
      {labels.map((label, index) => (
        <S.Button
          key={index}
          isSelected={label.value === selectedTab}
          onClick={
            onClicks[
              labels.findIndex((element) => {
                return element === label;
              })
            ]
          }
        >
          {label.text}
        </S.Button>
      ))}

      <S.Filter>
        {order && onChange && (
          <S.Select
            name="Ordenação"
            id="ordencao"
            onChange={(event: React.ChangeEvent<HTMLSelectElement>) => {
              onChange(event.target.value as FindOptionsOrderValue);
            }}
          >
            <option value={"DESC"}>Ordenação: Nenhuma</option>
            <option value={"DESC"}>Ordenação: Mais recente</option>
            <option value={"ASC"}>Ordenação: Mais antigas</option>
          </S.Select>
        )}
      </S.Filter>
    </S.Container>
  );
}
